'use strict';
const angular = require('angular');

export class codemirrorHtmlFormComponent {
  /*@ngInject*/
  constructor() {
    this.beautify_html = require('js-beautify').html;

    this.active = 0;
    
    this.treeOptions = {
      nodeChildren: "children",
      dirSelectable: false,
      injectClasses: {
        ul: "a1",
        li: "a2",
        liSelected: "a7",
        iExpanded: "a3",
        iCollapsed: "a4",
        iLeaf: "a5",
        label: "a6",
        labelSelected: "a8"
      }
    };

    this.snippets = [
      { name: 'Layout', children:[
        { "id": "layout.two-equal-cols", "name": "Two Equal Columns", children:[]},
        { "id": "layout.two-columns-2-1", "name": "Two Columns (66% / 33%)", children:[]}
      ]},
      {
        name: "Page Templates", "children": [
          { "id": "page.basic", "name" : "Basic Page Template", "description" : "A basic page template with one column", "children" : [] },
          { "id": "page.frontpage-parallax-full", "name" : "Frontpage Parallax (Complete)", "children" : [] }
      ]}
    ];
  }

  $onInit = function () {
    this.config = this.resolve.config;
    this.html = this.beautify_html(angular.copy(this.config.data),{indent_size: 2});

    CodeMirror.defineOption("mode", "text/html");
    CodeMirror.defineOption("htmlMode", true);
    CodeMirror.defineOption("lineWrapping", true);
    CodeMirror.defineOption("styleActiveLine", true);
    CodeMirror.defineOption("matchClosing", true);
    //CodeMirror.defineOption("lineNumbers", true);
    CodeMirror.defineOption("tabSize", 2);
    //CodeMirror.defineOption("gutters", ["CodeMirror-lint-markers"]);
    CodeMirror.defineOption("lint", true);
  };

  ok() {
    this.close({$value: this.html});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  updateSnippet(id) {

    try {
      this.snippet = require('../html-page-snippets/'+id+".html")
    } catch(e) {
      console.log(e);
    }

  }

}

export default angular.module('conduApp.codemirrorHtmlForm', [])
  .component('codemirrorHtmlForm', {
    template: require('./codemirror-html-form.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: codemirrorHtmlFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/codemirror-html-form/codemirror-html-form.component.js